import {AxiosResponse} from 'axios'
import Client from 'core/api/client'
import {IanaTimezone} from 'core/utils/timezone'
import authHeaders from './authHeaders'

/**
 * Expected payload for PATCH /study/reviewer endpoint
 */
export interface IApproveReviewer {
  email: string
  isApproved: boolean
  approvedTime?: string
}

interface IApproveReviewerResponseBody extends IApproveReviewer {
  email: string
}

/**
 * Expected response for PATCH /study/reviewer endpoint
 */
export interface IApproveReviewerResponse extends AxiosResponse {
  data: IApproveReviewerResponseBody
}

export function approveReviewer(token: string, id: string, data: IApproveReviewer ): Promise<IApproveReviewerResponse> {
  const url = `/study/reviewer/${id}`;
  return Client.patch(url, data, { ...authHeaders(token), validateStatus: () => true });
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./core/src/api/study_reviewer/approveReviewer.ts